import type { FieldProps } from 'formik';
import { Field } from 'formik';
import React from 'react';
import * as styles from './AddSeriesRadioButton.module.scss';
import { getFormikProps } from '../../components/formInternals/FormikFormField';

interface AddSeriesRadioButtonProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  icon: React.ReactNode;
  title: string;
}

const AddSeriesRadioButton = ({
  icon,
  title,
  ...props
}: AddSeriesRadioButtonProps) => {
  const fieldProps = {
    ...props,
    type: 'radio' as const,
  };

  return (
    <Field {...fieldProps}>
      {(formikProps: FieldProps) => (
        <label>
          <input
            className={styles.input}
            {...getFormikProps(fieldProps, formikProps)}
          />
          <div className={styles.track}>
            <div className={styles.icon}>{icon}</div>
            {title}
          </div>
        </label>
      )}
    </Field>
  );
};

export default AddSeriesRadioButton;
